module.exports = __webpack_public_path__ + "static/media/XML_import_template.679c8a02.xml";